/*
 * @Description:
 * @Author: kangkang
 * @Date: 2023-04-08 00:23:53
 * @LastEditTime: 2023-04-09 18:40:54
 * @LastEditors: kangkang
 * @Reference:
 */
import Vue from 'vue'
import Vuex from 'vuex';
import axios from "axios";
import moment from 'moment';
import api from '../api/index';

Vue.use(Vuex)
const key = 'token'
export default new Vuex.Store({
    time: {
        refreshTime: 0
    },
    getters: {
        getSortage: function (state) {
            console.log(state)

        },

    },
    matution: {

    },
    actions: {
        // 获取刷新token的列表
        async doGetRefreshToken(context,num) {
            await api.index.getRefreshToken().then((res) => {
                sessionStorage.access_token = res.access_token;
                sessionStorage.refresh_token = res.refresh_token;
                let date = parseInt(moment(new Date()).valueOf() / 1000);
                sessionStorage.requestTime = date;//请求token 的时间
            })
        }
    },
    mutations: {


    },


})
